import NextLink from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { Badge } from '@mui/material';
import { UserTypeEnum } from 'enums';
import BaseLayout from 'layouts/BaseLayout';
import { Container, Header, Title, Nav, NavTab } from './styles';
import { COLOR_WHITE } from 'styles/variables/colors';
import getCleverTap from 'utils/clevertap';
import { useAuthUser } from 'features/auth/AuthUserContext';

export default function MyAccount({ children }) {
  const router = useRouter();
  const { user } = useAuthUser();
  const isChina = user?.country_code === 'CN';
  const clevertap = getCleverTap();
  const items = [
    {
      label: 'Overview',
      path: '/my-account/overview',
      new: false,
    },
    {
      label: 'Profile',
      path: '/my-account/profile/general',
      new: false,
    },
    {
      label: 'Plan and Billing',
      path: '/my-account/billing/plan',
      new: false,
    },
    {
      label: 'Team',
      path: '/my-account/team',
      new: false,
    },
    {
      label: 'Friends Referral',
      path: '/my-account/invites',
      new: true,
    },
  ];
  const [navItems, setNavItems] = useState(items.slice(0, 3));

  useEffect(() => {
    const isAdmin = user?.tp_user === UserTypeEnum.ADMIN;
    const isLabResearcher = user?.tp_user === UserTypeEnum.LAB_RESEARCHER;
    const isLabResearcherMember = user?.team !== 1 && user?.tp_user !== UserTypeEnum.LAB_RESEARCHER;
    const isJournalMember = user?.tp_user === UserTypeEnum.JOURNAL;

    if (isAdmin || isLabResearcher) {
      const newItems = items.filter((item) => item.label !== 'Friends Referral');
      setNavItems(newItems);
    }

    if (isLabResearcherMember) {
      const newItems = items.filter((item) => !['Team', 'Friends Referral'].includes(item.label));
      setNavItems(newItems);
    }

    if (isJournalMember) {
      const newItems = items.filter(
        (item) => !['Profile', 'Plan and Billing', 'Friends Referral', 'Team'].includes(item.label),
      );
      setNavItems(newItems);
    }
  }, [user]);

  function isNavItemActive(item) {
    if (router.asPath.includes(item.path.split('/')[2])) {
      clevertap.event.push('Clicks to view information detail', {
        Product: 'MTG',
        Email: user?.email,
        'Country code': user?.country_code,
        URL: router.asPath,
        Description: `${item.label} Click`,
      });
    }

    return router.asPath.includes(item.path.split('/')[2]);
  }

  return (
    <BaseLayout
      bgBrandColor={COLOR_WHITE}
      headerWhite={true}
      typeBtn="buttonSecondary"
      hasPadding={false}
    >
      <Header>
        <Container>
          <Title>My Account</Title>
          <Nav>
            {navItems.map((item, index) => (
              <NextLink key={index} href={item.path} passHref={true}>
                {item.new ? (
                  <Badge color="secondary" badgeContent="New">
                    <NavTab isActive={isNavItemActive(item)}>{item.label}</NavTab>
                  </Badge>
                ) : (
                  <NavTab isActive={isNavItemActive(item)}>{item.label}</NavTab>
                )}
              </NextLink>
            ))}
          </Nav>
        </Container>
      </Header>

      <Container style={{ minWidth: isChina && 1200 }}>{children}</Container>

      <div style={{ paddingBottom: 60 }} />
    </BaseLayout>
  );
}
